const React = require('react');

const Layout = require('./src/components/layout').default;
require( '@fontsource/courier-prime');

exports.wrapPageElement = ({ element, props }) => (
	<Layout {...props}>{element}</Layout>
);
